module.exports = __webpack_public_path__ + "img/DSC_0059-2.7ec3390c.jpg";